import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';

import { ApiEndpoints } from '../constants/api-endpoints';
import { ApiService } from './api.service';
import { SubscriptionService } from './subscription.service';

@Injectable({ providedIn: 'root' })
export class RenterService {
  constructor(
    private readonly api: ApiService,
    private readonly subscriptionService: SubscriptionService
  ) {}

  list(payload: any = {}): Observable<any> {
    return this.api.postHandler(ApiEndpoints.RENTER_LIST, payload);
  }

  create(payload: any): Observable<any> {
    return this.api.postHandler(ApiEndpoints.RENTER_CREATE, payload).pipe(
      tap((res: any) => {
        if (`${res?.code ?? ''}` === '000') {
          this.subscriptionService.requestSummaryRefresh();
        }
      })
    );
  }

  update(payload: any): Observable<any> {
    return this.api.postHandler(ApiEndpoints.RENTER_UPDATE, payload);
  }

  delete(payload: any): Observable<any> {
    return this.api.postHandler(ApiEndpoints.RENTER_DELETE, payload).pipe(
      tap((res: any) => {
        if (`${res?.code ?? ''}` === '000') {
          this.subscriptionService.requestSummaryRefresh();
        }
      })
    );
  }

  restore(payload: any): Observable<any> {
    return this.api.postHandler(ApiEndpoints.RENTER_RESTORE, payload).pipe(
      tap((res: any) => {
        if (`${res?.code ?? ''}` === '000') {
          this.subscriptionService.requestSummaryRefresh();
        }
      })
    );
  }
}
